module.exports = __webpack_public_path__ + "static/media/java.1c28331e.png";